import { ClosedLoopEntityType, ClosedLoopEntityTypeId, DonationType } from '@nkr/enums/index';
import { IDonorRegistration } from '@nkr/models/index';
import { ButtonToolbar, Label, OverlayTrigger, Popover } from 'react-bootstrap';

const ClosedLoopLinkedDonorTypeRenderer = (data: IDonorRegistration) => {
    let style = data.closeLoopSurgeryDateTime == null ? '' : 'danger';
    let label = data.closeLoopSurgeryDateTime == null ? '--' : 'UNK';
    let msg   = 'Missing information';

    if (data.closeLoopEntityType == ClosedLoopEntityType.DonorShieldConfirmation) {
        style = 'info';
        label = 'DSD';
        msg   = "Confirmed Donor Shield Direct Donor";
    }
    else if( data.closeLoopEntityType == ClosedLoopEntityType.NkrDonorConfirmation ) {
        style = 'danger';
        label = 'NKR?';
        switch( data.closeLoopLinkedDonorType )
        {
            case DonationType.DirectedDonor:
            case DonationType.Bridge: style = "default"; label = 'Paired'; msg = "Confirmed NKR Pair"; break;
            case DonationType.NonDirectedDonor: style = 'warning'; label = 'NDD'; msg = "Confirmed NKR NDD"; break;
            case DonationType.StandardVoucher: style = 'success'; label = 'SV'; msg = "Confirmed NKR Standard Voucher"; break;
            case DonationType.FamilyVoucher: style = 'success'; label = 'FV'; msg = "Confirmed NKR Family Vouhcer"; break;
            case DonationType.SwapSaver: style = 'success'; label = 'SS'; msg = "Confirmed NKR Swap Saver"; break;
            case DonationType.RealTimeSwapFailure: style = 'success'; label = 'RTSF'; msg = "Confirmed NKR Real-Time Swap Failure"; break;
            case DonationType.RemoteDirect: style = 'info'; label = 'RD'; msg = "Confirmed NKR Remote Donor"; break;
            case DonationType.KflInternalDirect: style = 'info'; label = 'KFL ID'; msg = "Confirmed NKR KFL Internal Direct"; break;
            case DonationType.KflRemoteDirect: style = 'info'; label = 'KFL RD'; msg = "Confirmed NKR KFL Remote Direct"; break;
            case DonationType.NkrInternalDirect: style = 'info'; label = 'NKR ID'; msg = "Confirmed NKR Internal Direct"; break;
        }
    }
    else if (data.closeLoopEntityType == ClosedLoopEntityType.ManualConfirmation) {
        switch (data.closeLoopEntityTypeId) {
            case ClosedLoopEntityTypeId.AlternateKpdProgram: label = 'ALT-KPD'; msg = "Alt KPD Program"; break;
            case ClosedLoopEntityTypeId.NonDirected: label = 'I-NDD'; msg = "Center Internal NDD"; break;
            case ClosedLoopEntityTypeId.ToWaitlist: label = 'I-WLP'; msg = "Center to Internal Waitlist"; break;
            case ClosedLoopEntityTypeId.Direct: label = 'I-D'; msg = "Center Internal Direct"; break;
            case ClosedLoopEntityTypeId.InternalKpd: label = 'I-KPD'; msg = "Center Internal KPD"; break;
            case ClosedLoopEntityTypeId.NkrKpd: label = 'Paired?'; msg = "Link Missing - Unconfirmed NKR Paired Donor"; break;
            case ClosedLoopEntityTypeId.StandardVoucher: label = 'SV?'; msg = "Link Missing - Unconfirmed NKR SV Donor"; break;
            case ClosedLoopEntityTypeId.FamilyVoucher: label = 'FV?'; msg = "Link Missing - Unconfirmed NKR FV Donor"; break;
            case ClosedLoopEntityTypeId.NonDirectedNkr: label = 'NDD?'; msg = "Link Missing - Unconfirmed NKR NDD"; break;
            case ClosedLoopEntityTypeId.KidneyForLifeInternal: label = 'KFL ID?'; msg = "Link Missing - Unconfirmed NKR KFL ID"; break;
            case ClosedLoopEntityTypeId.RemoteDirectNkr: label = 'NKR RD?'; msg = "Link Missing - Unconfirmed NKR ID"; break;
        }
    }

    return label == '--' ? <>--</> : <ButtonToolbar>
        <OverlayTrigger
            trigger={['hover', 'focus', 'click']}
            placement='bottom'
            overlay={<Popover id='popover-trigger-hover-focus'>{msg}</Popover>}>
            <Label bsStyle={style} title={msg}>{label}</Label>
        </OverlayTrigger>
    </ButtonToolbar>
}

export default ClosedLoopLinkedDonorTypeRenderer;